import { render, staticRenderFns } from "./EditNoteBlockModal.vue?vue&type=template&id=c5c1e4a2&lang=pug&"
import script from "./EditNoteBlockModal.vue?vue&type=script&lang=js&"
export * from "./EditNoteBlockModal.vue?vue&type=script&lang=js&"
import style0 from "./EditNoteBlockModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports